import { SET_IMAGE_AND_MASK_URL, SET_MASK_DATA, MASK_LOADED } from "../actions/imageActions";
import ImagesState from "../stateTypes/imagesState";

const initialState: ImagesState = {
    maskElement: null,
    imageAndMask: null,
    maskMetadata: null,
    maskData: null,
};

const imagesReducer = (state: ImagesState = initialState, action: any = {}) => {
    switch (action.type) {
        case MASK_LOADED:
            return {
                ...state,
                maskElement: action.maskElement,
            };
        case SET_IMAGE_AND_MASK_URL:
            return {
                ...state,
                imageAndMask: action.imageAndMask,
            };
        case SET_MASK_DATA:
            return {
                ...state,
                maskMetadata: action.maskMetadata,
                maskData: action.maskData,
            };
        default:
            return state;
    }
};

export default imagesReducer;
